import { ReactElement, SVGProps } from "react";
import BaseIcon from "./BaseIcon";

export default function ExpandCircleRightIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 16 16">
      <path d="M7.45 7 5.867 8.583a.62.62 0 0 0-.184.459.68.68 0 0 0 .184.475q.2.2.475.2a.65.65 0 0 0 .475-.2l2.05-2.05a.64.64 0 0 0 .2-.467.64.64 0 0 0-.2-.467L6.8 4.467a.61.61 0 0 0-.467-.192.67.67 0 0 0-.466.208.7.7 0 0 0-.192.467.61.61 0 0 0 .192.467zM7 13.667a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 .858 9.6 6.5 6.5 0 0 1 .333 7q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.425A6.5 6.5 0 0 1 7 .333q1.383 0 2.6.525t2.117 1.425T13.142 4.4t.525 2.6-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525" fill="currentColor"/>
    </BaseIcon>
  );
}
